import { Link, useHistory  } from "react-router-dom";
import { getSession } from "../global";
import Logo from '../images/logo.png';
import { FaHome, FaClipboardList, FaTruckMoving, FaChartLine, FaUserCog, FaFileAlt, FaChevronLeft, FaChevronRight, FaEllipsisV, FaArrowAltCircleLeft , FaAngleDoubleLeft , FaGripLines , FaBars   } from "react-icons/fa";
import { useState } from "react";


const Sidebar = () => {
      const [collapsed, setCollapsed] = useState(false);

  const getMenuIcon = (menuName) => {
        switch (menuName?.toLowerCase()) {
            case "home":
            return <FaHome color="#007bff" size={18} />;
            case "booking":
            return <FaClipboardList color="#e67e22" size={18} />;
            case "tracking":
            return <FaTruckMoving color="#17a2b8" size={18} />;
            case "reports":
            return <FaChartLine color="#28a745" size={18} />;
            case "setup":
            return <FaUserCog color="#6c757d" size={18} />;
            default:
            return <FaFileAlt color="#adb5bd" size={18} />; // fallback icon
        }
    };
      
    const history  = useHistory();


    return <div className="main-sidebar">

            <button
                className="sidebar-toggle-tab"
                data-toggle="sidebar"
            >
                <FaBars  />
            </button>
                

       

      
        
        <aside id="sidebar-wrapper">
            <div className="sidebar-brand mt-3" onClick={() => history.push("/")} style={{cursor: "pointer"}}>
                <img src={Logo} style={{ width: '50%' }} />
                <h5 className="mt-3">Customer Portal</h5>
            </div>
            <div className="sidebar-brand sidebar-brand-sm" onClick={() => history.push("/")} style={{cursor: "pointer"}}>
                <img src={Logo} alt="logo" width={100} className="logo mt-3" />
                <h3 className="mt-3">Customer Portal</h3>
            </div>
            <ul className="sidebar-menu mt-5">
                {/* <li style={{ textAlign: "center" }}><input id="searchMenu" placeholder="Search Menu" className="formc-control" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} /></li> */}
                {
                    getSession('menues') && getSession('menues').map((x, index) =>
                        <li className="nav-item dropdown" key={index}  >
                            <a href="#" className="nav-link has-dropdown" >
                                {getMenuIcon(x.menu)}
                            <span>{x.menu}</span></a>
                            <ul className="dropdown-menu">

                                {/* {
                                    x.menu === "Tracking" && <li className="active">
                                        <Link className="nav-link" to={"/Tracking_2"}>tracking revamp</Link>
                                    </li>
                                }  */}

                                {
                                    x.subMenus.map((z, index2) =>
                                        <li className="active" key={index2}>
                                            <Link className="nav-link" to={z.hyperLink}>{z.submenu}</Link>
                                        </li>)
                                }

                            </ul>
                        </li>
                    )
                }
            </ul>
        </aside>


    </div>
}

export default Sidebar;

// const Menu = ({ x }) => {
//     const [expanded, setExpanded] = useState(true);
//     return <li className="nav-item dropdown">
//         <a href="#" className="nav-link" ><i className="far fa-file" /><span>{x.menu}</span></a>
//         {
//             expanded &&
//             <ul className="dropdown-menu">
//                 {
//                     x.subMenus.map((z, index) =>
//                         <li key={index}>
//                             <Link className="nav-link" to={z.hyperLink}>{z.submenu}</Link>
//                         </li>)
//                 }
//             </ul>
//         }
//     </li>
// }